import React from 'react';
import { Link } from 'react-router-dom';
import fabricsData from '../data/fabricsData';

function Fabrics() {
  return (
    <div className="fabrics">
      <h1 className="section-title">Fabric Dyeing Techniques</h1>
      <div className="fabrics__grid">
        {fabricsData.map((item) => (
          <div key={item.id} className="fabrics__item">
            <Link to={`/fabrics/${item.id}`}>
              <img 
                src={process.env.PUBLIC_URL + item.image} 
                alt={item.name} 
                className="fabrics__image"
              />
              <h3 className="fabrics__title">{item.title}</h3>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Fabrics;
